export default "__VITE_ASSET__93227ea3__$_?nuxt_component=async__"